import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal.js'
import Paging from '../../components/Paging'
import qs from 'qs'
import queryString from 'query-string'
import fp from 'lodash/fp'
import FormDropdown from '../../components/FormDropdown'
import XLSX from 'xlsx'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import IzinModalGuru from "../../components/IzinModalGuru";
import ModalHelp from "../../components/ModalHelp";

const normalizeLevelName = (str) => {
    return fp.startCase(str.replace("_", " "))
}

// const yourDate = new Date()
const NewDateStart  = moment().format('YYYY-MM-DD')
const NewDateEnd    = moment().format('YYYY-MM-DD')

class NotTakenGuru extends Component {

    constructor() {
        super();
        this.state = {
            dataUsersGur    : [],
            dataExport   : [], // data export siswa
            dataKelas    : [],
            pageCount    : 0,
            perPage      : 20,
            currentPage  : 0,
            user_id      : 0,
            kelas_id     : "",
            user_name_guru    : "",
            tutorial: '',
            isModalHelpShow  : false,
            dateNowStartG : NewDateStart,
            dateNowEndG   : NewDateEnd,
            isButtonLoading: false,
            dateStartG    : moment(),
            dateEndG     : moment(),
            dateG         : moment(),
            isLoading    : true,
            isModalShow  : false,
        }

        this.handleChange               = this.handleChange.bind(this)
        this.handlePageClick            = this.handlePageClick.bind(this)
        this.handleChangeDatepickerStart   = this.handleChangeDatepickerStart.bind(this);
        this.handleChangeDatepickerEnd     = this.handleChangeDatepickerEnd.bind(this);
        this.toggleModalGuru = this.toggleModalGuru.bind(this);
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)
    }

    toggleModalHelp() {

        this.setState({tutorial : 'https://www.youtube.com/embed/vYRPDIUi-oY'})

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }

    toggleModalGuru() {
        this.setState({ isModalShow: !this.state.isModalShow });
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadData();
        });
    };

    handleChangeDatepickerStart(e) {
        this.setState({
            dateStartG:e,
            dateNowStartG:e.format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
            this.loadData();
        })
    }

    handleChangeDatepickerEnd(e) {
        this.setState({
            dateEndG:e,
            dateNowEndG:e.format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
            this.loadData();
        })
    }

    loadData() {

        let sortirLevel;

        sortirLevel = "guru"

        this.setState({ isButtonLoading: true });
        this.setState({ isLoading: true })

        const params = qs.stringify({
            page : this.state.currentPage + 1,
            level: sortirLevel,
            guru: this.state.user_name_guru,
            dateStartG: this.state.dateNowStartG,
            dateEndG: this.state.dateNowEndG
        })

        axios.post("/reportnottaken?" + params)
            .then(response => {

                const result = response.data
                if (result.success) {
                    this.setState({
                        dataUsersGur  : result.data.data,
                        pageCount  : result.last_page,
                        isLoading  : false,
                        isButtonLoading  : false
                    })
                }else{
                    this.setState({ isLoading: false })
                    Alert.error(result.message)
                }
            })
            .catch((error) => {

                console.log(error)

                this.setState({ isLoading: false })

                Alert.error("Gagal terhubung ke server!")
            })
    }


    componentDidMount() {

        let sortirLevel;

        sortirLevel = "guru"
        this.loadData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.user_name_guru !== this.state.user_name_guru) {
            this.loadData()
        }
    }

    render () {
        let sortirLevel;
        let levelName;

        sortirLevel = "guru"
        levelName = "Guru"

        return (
            <div className="col-lg-6">
                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />
                <IzinModalGuru
                    isShow={this.state.isModalShow}
                    toggleModalGuru={this.toggleModalGuru}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Presensi"
                    modalBodyText= {this.state.guruId}
                    guruId = {this.state.guruId}
                    nama = {this.state.nama}
                    tgl = {this.state.tgl}
                    type = {this.state.type}
                    modalSubmitText="Ya"
                />
                <div className="card">
                    <div className="card-header">
                        Data {levelName}
                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-12 form-group row">
                                <label className="col-md-2 form-control-label">
                                    <b>Nama</b>
                                </label>
                                <div className="col-md-10">
                                    <input
                                        name="user_name_guru"
                                        type="text"
                                        className="form-control"
                                        placeholder="Ketikkan Nama Pengguna ..."
                                        value={this.state.user_name_guru}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>

                            <div className="col-md-12 form-group row">

                                <label className="col-md-2 form-control-label">
                                    <b>Tanggal</b>
                                </label>

                                <div className="col-md-4">

                                    <DatePicker
                                        selected={this.state.dateStartG}
                                        onChange={this.handleChangeDatepickerStart}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                    />
                                </div>

                                { sortirLevel === 'siswa'  ? ( "-" ) : " " }

                                <div className="col-md-4">

                                    <DatePicker
                                        selected={this.state.dateEndG}
                                        onChange={this.handleChangeDatepickerEnd}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                    />

                                </div>
                            </div>
                        </div>

                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.dataUsersGur.length === 0 ? "Data Kosong..." : (
                                    <div>
                                        <table className="table table-striped animated fadeIn">
                                            <thead>
                                            <tr>
                                                <th width={190}>Nama Lengkap</th>
                                                <th>Tipe</th>
                                                <th>Tanggal</th>
                                                <th width={100}>Opsi</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.dataUsersGur.map((item, i) => {

                                                    return (
                                                        <tr key={i}>
                                                            <td>{item.name}</td>
                                                            <td>{item.type}</td>
                                                            <td>{item.date}</td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() => {
                                                                        this.toggleModalGuru();
                                                                        this.setState({
                                                                            guruId: item.guru_id,
                                                                            nama:item.name,
                                                                            tgl:item.date,
                                                                            type:item.type
                                                                        });
                                                                    }}
                                                                >
                                                                    <i className="fa fa-edit"></i> Edit
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>

                                        <Paging
                                            handlePageClick={this.handlePageClick}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default NotTakenGuru;


// WEBPACK FOOTER //
// ./src/views/ReportPresensi/NotTakenGuru.js